import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV !== 'test' && process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    defaults: '2026-01-30',
    // Nothing is captured (no pageview, no autocapture) until AuthContext knows
    // the user is a client and opts them in; internal users never send anything.
    opt_out_capturing_by_default: true,
    debug: process.env.NODE_ENV === 'development',
  });
}

async function bootstrap() {
  if (process.env.REACT_APP_DEMO_MODE === 'true') {
    const { worker } = await import('./mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  reportWebVitals();
}

bootstrap();
